import React, {Component} from 'react';
import { Card, CardHeader, CardBody, Input, InputGroup, InputGroupAddon, Button } from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import md5 from 'md5';

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter, numberFilter } from 'react-bootstrap-table2-filter';

import ClientSearch from '../../components/Client/Search';
import ClientEditor from '../../components/Client/Editor';

import Config from '../../config';

import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './List.css';

class ClientList extends Component {
 constructor(props) {
  super(props);

  this.state = {
   page: 1,
   data: [],
   passwd: '',
   client: null,
   totalSize: 0,
   sizePerPage: 10,
   editorWindow: false,
   selected: []
  };

  this.filters = {}
  this.columns = [
   { dataField: 'NID', text: 'Nº Identidad', filter: textFilter({ getFilter: (filter) => { this.filters.nid = filter } }), headerStyle: () => { return { width: '125px' } }, sort: true },
   { dataField: 'name', text: 'Nombre', filter: textFilter({ getFilter: (filter) => { this.filters.name = filter } }), sort: true },
   { dataField: 'address', text: 'Dirección', filter: textFilter({ getFilter: (filter) => { this.filters.address = filter } }), sort: true },
   { dataField: 'locality', text: 'Ciudad', filter: textFilter({ getFilter: (filter) => { this.filters.locality = filter } }), sort: true },
   { dataField: 'state', text: 'Provincia', filter: textFilter({ getFilter: (filter) => { this.filters.state = filter } }), sort: true },
   { dataField: 'postcode', text: 'Código Postal', filter: textFilter({ getFilter: (filter) => { this.filters.postcode = filter } }), headerStyle: () => { return { width: '140px' } }, sort: true },
   { dataField: 'ID', text: 'Acciones', headerStyle: () => { return { width: '108px' } }, headerFormatter:() => (
    <Button className="float-right" title="Restablecer filtros" onClick={this.resetFilters}><i className="fa fa-filter"></i>&nbsp;Limpiar</Button>
   ), formatter: (cellContent, row) => (
    <div className="checkbox disabled">
     <Button color="primary" onClick={() => this.openEditor(cellContent)}><i className="fa fa-edit"></i></Button>
     {' '}
     <Button color="danger" onClick={() => this.doDelete(cellContent)}><i className="fa fa-trash"></i></Button>
    </div>
   )}
  ];

  this.doDelete = this.doDelete.bind(this);

  this.openEditor = this.openEditor.bind(this);
  this.closeEditor = this.closeEditor.bind(this);

  this.resetFilters = this.resetFilters.bind(this);
  this.handleOnSelect = this.handleOnSelect.bind(this);
  this.handleOnSelectAll = this.handleOnSelectAll.bind(this);
  this.handleTableChange = this.handleTableChange.bind(this);
  this.handleClickDelete = this.handleClickDelete.bind(this);
 }

 resetFilters() {
  this.filters.nid('');
  this.filters.name('');
  this.filters.address('');
  this.filters.locality('');
  this.filters.state('');
  this.filters.postcode('');
  //this.filters.country('');
 }

 handleOnSelect(row, isSelect, rowIndex, e) {
  if (isSelect) {
   this.setState({ selected: [...this.state.selected, row.ID] });
  } else {
   this.setState({ selected: this.state.selected.filter(x => x !== row.ID) });
  }
 }

 handleOnSelectAll(isSelect, rows, e) {
  const IDs = rows.map(r => r.ID);
  if (isSelect) {
   this.setState({ selected: [...this.state.selected, ...IDs] });
  } else {
   this.setState({ selected: this.state.selected.filter((e) => { return IDs.indexOf(e) < 0 }) });
  }
 }

 handleTableChange(type, { page, sizePerPage, filters, sortField, sortOrder }) {
  this.props.reqAPI(Config.apiURI+'/api/clients', 'POST', { page, sizePerPage, filters, sortField, sortOrder }).then(data => {
   this.setState(() => ({ page, data: data.items, totalSize: data.total, sizePerPage, filters, sortField, sortOrder }));
  });
 }

 handleClickDelete(IDs, onClose) {
  this.props.reqAPI(Config.apiURI+'/api/clients/delete', 'POST', {
   clients: IDs,
   passwd: md5(this.state.passwd)
  }).then(result => {
   onClose();
   if(!result.success) {
    this.doDelete(IDs, true);
    if(result.message) toast.error(result.message);
   } else {
    toast.success(IDs.length > 1 ? 'Los clientes han sido eliminados' : 'El cliente ha sido eliminado');
    this.setState({ selected: this.state.selected.filter((e) => { return IDs.indexOf(e) < 0 }) });
    this.handleTableChange('reload', {
     page: this.state.page,
     sizePerPage: this.state.sizePerPage,
     filters: this.state.filters,
     sortField: this.state.sortField,
     sortOrder: this.state.sortOrder
    });
   }
  }).catch((error) => {
   console.log(error);
  });
 }


 doDelete(ID, error = false) {
  var IDs = ID === null ? this.state.selected : typeof(ID) === 'object' ? ID : [ ID ];
  confirmAlert({
   customUI: ({ onClose }) => {
    return (
     <Card className='confirm-delete alert-danger'>
      <CardBody>
       <h2>Atención!</h2>
       <p>{IDs.length == 1 ? 'Se va a borrar un cliente.' : 'Se van a borrar '+IDs.length+' clientes.'}</p>
       <p><strong>Esta operación no podrá ser revertida. Desea continuar?</strong></p>
       <InputGroup>
        <Input type="password" autoComplete="new-password" placeholder="Confirme con su clave"
         onKeyPress={(event) => { if(event.key === 'Enter') this.handleClickDelete(IDs, onClose); }}
         onChange={(e) => { this.setState({passwd: e.target.value}); }}
         className={error ? 'border border-danger' : ''}
         defaultValue={this.state.passwd}
        />
        <InputGroupAddon addonType="append">
         <Button color="danger" onClick={() => { this.handleClickDelete(IDs, onClose); }}>Si, eliminar!</Button>
         <Button color="primary" onClick={onClose}>No, cancelar!</Button>
        </InputGroupAddon>
       </InputGroup>
      </CardBody>
     </Card>
    );
   }
  });
 }


 openEditor(ID) {
  if(ID === null) {
   this.setState({client: null}, function() {
    this.setState({editorWindow: true});
   });
  } else {
   this.props.reqAPI(Config.apiURI+'/api/clients/'+ID+'?full').then(client => {
    this.setState({client: client}, function() {
     this.setState({editorWindow: true});
    });
   })
  }
 }

 closeEditor(state) {
  if(state) toast.success('Los cambios han sido guardados');
  this.setState({client: null, editorWindow: false});
  this.handleTableChange('reload', {
   page: this.state.page,
   sizePerPage: this.state.sizePerPage,
   filters: this.state.filters,
   sortField: this.state.sortField,
   sortOrder: this.state.sortOrder
  });
 }


 render() {
  return (
   <Card>
    <CardHeader>
     <ClientSearch reqAPI={this.props.reqAPI} handleInputEL={()=> (console.log())} handleCallback={(e)=> (this.openEditor(e.ID))} placeholder="Busca un cliente para editarlo" />
    </CardHeader>

    <CardBody>
     <Button color="success" onClick={() => this.openEditor(null)}><i className="fa fa-plus"></i> Nuevo cliente</Button>
     {' '}
     {this.state.selected.length > 0 ? <Button color="danger" onClick={() => this.doDelete(null)}><i className="fa fa-minus"></i> Eliminar seleccionados</Button> :''}

     <BootstrapTable
      remote
      striped
      condensed
      bootstrap4
      keyField="ID"
      bordered={ false }
      data={ this.state.data }
      columns={ this.columns }
      selectRow={{
       mode: 'checkbox',
       onSelect: this.handleOnSelect,
       onSelectAll: this.handleOnSelectAll
      }}
      defaultSorted={ [{
       dataField: 'name',
       order: 'asc'
      }] }
      filter={ filterFactory() }
      pagination={
       paginationFactory({
        page: this.state.page,
        sizePerPage: this.state.sizePerPage,
        sizePerPageList: [
         { text: '5', value: 5 },
         { text: '10', value: 10 },
         { text: '25', value: 25 },
         { text: '50', value: 50 },
         { text: '100', value: 100 }
        ],
        showTotal: true,
        totalSize: this.state.totalSize,
        firstPageText: 'First',
        prePageText: 'Back',
        nextPageText: 'Next',
        lastPageText: 'Last',
        nextPageTitle: 'First page',
        prePageTitle: 'Pre page',
        firstPageTitle: 'Next page',
        lastPageTitle: 'Last page',
        paginationTotalRenderer: (from, to, size) => (
         <span className="react-bootstrap-table-pagination-total">
          &nbsp;Mostrando del <strong>{ from } al { to }</strong> de un total de <strong>{ size } clientes</strong>
         </span>
        )
       })
      }
      onTableChange={ this.handleTableChange }
      noDataIndication="Table is Empty"
     />
    </CardBody>

    <ClientEditor reqAPI={this.props.reqAPI} open={this.state.editorWindow} client={this.state.client} handleClose={this.closeEditor} onComplete={this.closeEditor} />
   </Card>
  )
 }
}

export default ClientList;



// WEBPACK FOOTER //
// ./src/views/Clients/List.js